var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"bread-crumbs",attrs:{"aria-label":_vm.$snippet('breadcrumbs_aria_label', 'breadcrumbs')}},[_c('b-breadcrumb',{attrs:{"items":_vm.crumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }